import { render, staticRenderFns } from "./StatsMyView.vue?vue&type=template&id=0a5a6f1a"
import script from "./StatsMyView.vue?vue&type=script&lang=js"
export * from "./StatsMyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports